import {tag2url} from '@yandex-delivery/utils'
import type {CardSystem} from '@yandex-delivery/api/model/payment'
import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import maestroSrcDesktop from './assets/desktop/Maestro.svg'
import masterCardSrcDesktop from './assets/desktop/MasterCard.svg'
import mirSrcDesktop from './assets/desktop/Mir.svg'
import visaSrcDesktop from './assets/desktop/Visa.svg'
import iconSrcNoneMobile from './assets/mobile/Placeholder.svg'
import {IconSlugMobile} from './constants/icon-slug@mobile'

export const desktopClasses = {
  logo: css`
    inline-size: 100%;
    block-size: 24px;
    background: left / contain no-repeat;
  `,
}

export const desktopSystemClasses: Record<CardSystem, string> = {
  maestro: css`
    background-image: url(${maestroSrcDesktop});
  `,
  mastercard: css`
    background-image: url(${masterCardSrcDesktop});
  `,
  mir: css`
    background-image: url(${mirSrcDesktop});
  `,
  unknown: css``,
  visa: css`
    background-image: url(${visaSrcDesktop});
  `,
}

export const mobileClasses = {
  logo: css`
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(${iconSrcNoneMobile});
    background-color: ${cssTheme.colors.absolute.white};
    block-size: 24px;
    border-radius: ${spacing(0.5)};
    min-inline-size: 36px;
  `,
}

export const mobileSystemClasses: Record<CardSystem, string> = {
  maestro: css`
    background-image: url(${tag2url(IconSlugMobile.MAESTRO)});
  `,
  mastercard: css`
    background-image: url(${tag2url(IconSlugMobile.MASTERCARD)});
  `,
  mir: css`
    background-image: url(${tag2url(IconSlugMobile.MIR)});
  `,
  unknown: css`
    background-image: url(${tag2url(IconSlugMobile.UNKNOWN)});
  `,
  visa: css`
    background-image: url(${tag2url(IconSlugMobile.VISA)});
  `,
}
